export default "__VITE_ASSET__4FuPSZHn__"